export const common = {
  appName: 'Acework',
  appTagline: '网球社群',
  
  // Navigation
  matches: '比赛',
  stats: '统计',
  tournaments: '锦标赛',
  profile: '个人资料',
  
  // Common actions
  save: '保存',
  cancel: '取消',
  delete: '删除',
  edit: '编辑',
  back: '返回',
  next: '下一步',
  submit: '提交',
  confirm: '确认',
  close: '关闭',
  
  // Match related
  win: '胜',
  loss: '负',
  vs: '对战',
  score: '比分',
  date: '日期',
  location: '地点',
  opponent: '对手',
  singles: '单打',
  doubles: '双打',
  joined: '人',
  ranked: '积分赛',
  
  // Stats
  totalMatches: '总比赛数',
  wins: '胜场',
  losses: '负场',
  winRate: '胜率',
  currentStreak: '当前连胜',
  winsInARow: '连胜',
  keepItGoing: '继续保持！',
  performance: '表现',
  matchesPlayed: '已进行比赛',
  hoursOnCourt: '场上时间',
  
  // Time
  today: '今天',
  yesterday: '昨天',
  thisWeek: '本周',
  thisMonth: '本月',
  
  // Messages
  loading: '加载中...',
  noData: '暂无数据',
  error: '发生错误',
  success: '成功',
};
